export default __webpack_public_path__ + "static/media/beep_success.902361f9.wav";